import Path from '@leverege/path';
import { DateTime, Duration } from 'luxon';
function coerceEpoch(value, throwErr) {
  if (typeof value === 'number') {
    return value;
  }
  if (value instanceof DateTime) {
    return value.valueOf();
  }
  if (value instanceof Date) {
    return value.valueOf();
  }
  if (typeof value === 'string') {
    return DateTime.fromISO(value).valueOf();
  }
  if (typeof value === 'object') {
    return DateTime.fromObject(value).valueOf();
  }
  if (throwErr) {
    throw new Error('Invalid Date');
  }
  return null;
}
function coerceDate(value, throwErr = false) {
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return new Date(value);
  }
  if (value instanceof DateTime) {
    return value.toJSDate();
  }
  if (throwErr) {
    throw new Error('Invalid Date');
  }
  return null;
}
function coerceDateTime(value, throwErr = false) {
  if (value instanceof DateTime) {
    return value;
  }
  if (value instanceof Date) {
    return DateTime.fromJSDate(value);
  }
  if (typeof value === 'string') {
    return DateTime.fromISO(value);
  }
  if (typeof value === 'number') {
    return DateTime.fromMillis(value);
  }
  if (typeof value === 'object') {
    return DateTime.fromObject(value);
  }
  if (throwErr) {
    throw new Error('Invalid Date');
  }
  return null;
}
function getTickIncrement(range) {
  const {
    start,
    end
  } = range || {};
  const startDt = coerceDateTime(start);
  const endDt = coerceDateTime(end);
  const duration = Duration.fromDurationLike(endDt - startDt);
  if (duration.as('hours') < 24) {
    return Duration.fromObject({
      minute: 1
    }).toMillis();
  }
  if (duration.as('days') <= 7) {
    return Duration.fromObject({
      hour: 1
    }).toMillis();
  }
  return Duration.fromObject({
    day: 1
  }).toMillis();
}
function binaryTimeSearch(date, values, valueKey) {
  const target = coerceDate(date).getTime();
  if (Number.isNaN(target)) {
    return null;
  }
  let low = 0,
    high = values.length - 1;
  let best = null;
  let bestDiff = Infinity;
  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const midTime = coerceDate(valueKey ? Path.get(valueKey, values[mid]) : values[mid]);
    const diff = Math.abs(midTime - target);
    if (diff < bestDiff) {
      best = values[mid];
      bestDiff = diff;
    }
    if (midTime < target) {
      low = mid + 1;
    } else if (midTime > target) {
      high = mid - 1;
    } else {
      break;
    }
  }
  return best;
}
function findNextDate(date, values, valueKey) {
  const compare = coerceDateTime(date);
  const getter = valueKey ? new Path(valueKey).get : item => item;
  const next = values.find(val => coerceDateTime(getter(val)) > compare);
  return getter(next);
}
function convertPrecision(precision) {
  if (!precision) {
    return precision;
  }
  let unit;
  switch (precision.unit) {
    case 's':
      unit = 'seconds';
      break;
    case 'min':
      unit = 'minutes';
      break;
    case 'h':
      unit = 'hours';
      break;
    case 'day':
      unit = 'days';
      break;
    default:
      return null;
  }
  return {
    [unit]: precision.value
  };
}
export default {
  binaryTimeSearch,
  findNextDate,
  coerceDate,
  coerceDateTime,
  coerceEpoch,
  getTickIncrement,
  convertPrecision
};